// extracted by mini-css-extract-plugin
export default {"link":"trioItem-module__link--uF2xV","externalImg":"trioItem-module__externalImg--EvO2q","internalImg":"trioItem-module__internalImg--N4RJH"};